import {Store} from './store';
import propertyDefinitionsClient from 'common/report/queries/app-api/property-definitions-client';
import {PropertyDefinition} from 'common/util/definitions-types';

export const eventPropertyDefinitionsStore = new Store<PropertyDefinition[]>({
  apiClient: propertyDefinitionsClient,

  defaultValue: [],
});

export const peoplePropertyDefinitionsStore = new Store<PropertyDefinition[]>({
  apiClient: propertyDefinitionsClient,

  defaultValue: [],
});
